// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Scalars = require("../../scalars/Scalars.bs.js");
var UTCDate = require("../../reason/common/types/UTCDate.bs.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Intercom = require("../../reason/common/Intercom.bs.js");
var DateFns = require("date-fns");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var FeaturesV3 = require("../../reason/featureFlipper/FeaturesV3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var BillingSettingsPageSubscription_accountV5_graphql = require("../../__generated__/BillingSettingsPageSubscription_accountV5_graphql.bs.js");

var convertFragment = BillingSettingsPageSubscription_accountV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BillingSettingsPageSubscription_accountV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BillingSettingsPageSubscription_accountV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, BillingSettingsPageSubscription_accountV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BillingSettingsPageSubscription_accountV5_graphql.node, convertFragment, fRef);
}

var AccountFragment_accountStatusV5_decode = BillingSettingsPageSubscription_accountV5_graphql.Utils.accountStatusV5_decode;

var AccountFragment_accountStatusV5_fromString = BillingSettingsPageSubscription_accountV5_graphql.Utils.accountStatusV5_fromString;

var AccountFragment_planHandleV5_decode = BillingSettingsPageSubscription_accountV5_graphql.Utils.planHandleV5_decode;

var AccountFragment_planHandleV5_fromString = BillingSettingsPageSubscription_accountV5_graphql.Utils.planHandleV5_fromString;

var AccountFragment_planInterval_decode = BillingSettingsPageSubscription_accountV5_graphql.Utils.planInterval_decode;

var AccountFragment_planInterval_fromString = BillingSettingsPageSubscription_accountV5_graphql.Utils.planInterval_fromString;

var AccountFragment = {
  accountStatusV5_decode: AccountFragment_accountStatusV5_decode,
  accountStatusV5_fromString: AccountFragment_accountStatusV5_fromString,
  planHandleV5_decode: AccountFragment_planHandleV5_decode,
  planHandleV5_fromString: AccountFragment_planHandleV5_fromString,
  planInterval_decode: AccountFragment_planInterval_decode,
  planInterval_fromString: AccountFragment_planInterval_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function BillingSettingsPageSubscription$UpgradeToProButton(props) {
  var plan = UserSession.usePlan();
  var isOnTrial = UserSession.Plan.isTrial(plan);
  return JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              href: "/subscribe",
              size: "small",
              children: Caml_option.some(isOnTrial ? "Subscribe to PRO Membership" : "Upgrade to PRO Membership")
            });
}

var UpgradeToProButton = {
  make: BillingSettingsPageSubscription$UpgradeToProButton
};

function BillingSettingsPageSubscription(props) {
  var cancelProMembershipFlag = FeaturesV3.useFeatureFlipper("CancelProMembership");
  var cancelProMembershipEnabled = Caml_obj.equal(cancelProMembershipFlag, "on");
  var match = use(props.account);
  var subscription = match.sub;
  var match$1 = Intercom.useIntercom();
  var show = match$1.show;
  var match$2 = subscription.plan.interval;
  var intervalPeriod;
  if (match$2 === "QUARTER" || match$2 === "MONTH" || match$2 === "INDEFINITE" || match$2 === "YEAR") {
    switch (match$2) {
      case "INDEFINITE" :
          intervalPeriod = "Indefinite";
          break;
      case "MONTH" :
          intervalPeriod = "monthly";
          break;
      case "QUARTER" :
          intervalPeriod = "quarterly";
          break;
      case "YEAR" :
          intervalPeriod = "annually";
          break;
      
    }
  } else {
    intervalPeriod = "Indefinite";
  }
  var formattedDate = Core__Option.getOr(Core__Option.map(Core__Option.map(subscription.currentPeriodEnd, (function (x) {
                  return UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(x));
                })), (function (__x) {
              return DateFns.format(__x, "MMMM dd, yyyy");
            })), "[couldn't retrieve date]");
  var cancelAtPeriodEnd = Core__Option.isSome(subscription.cancelAt);
  if (match.accountStatus === "TERMINATED") {
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx("div", {
                        className: "mt-4"
                      }),
                  "Your Pro TAN membership has expired.",
                  JsxRuntime.jsx("div", {
                        className: "mt-4"
                      }),
                  JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                        href: "/subscribe",
                        size: "small",
                        children: "Reactivate Your Account"
                      })
                ]
              });
  }
  var match$3 = subscription.plan.handle;
  if (!(match$3 === "PRO_TRIAL" || match$3 === "PRO_QUARTERLY" || match$3 === "PRO_MONTHLY" || match$3 === "PRO_FREE" || match$3 === "FREE" || match$3 === "COMPLIMENTARY" || match$3 === "PRO_YEARLY")) {
    return null;
  }
  switch (match$3) {
    case "COMPLIMENTARY" :
        return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      JsxRuntime.jsx("div", {
                            className: "mt-4"
                          }),
                      "You have a complimentary Pro TAN membership"
                    ]
                  });
    case "FREE" :
        return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      JsxRuntime.jsx("div", {
                            className: "mt-4"
                          }),
                      "You are currently on the Free membership",
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx(BillingSettingsPageSubscription$UpgradeToProButton, {}),
                            className: "mt-4"
                          })
                    ]
                  });
    case "PRO_FREE" :
        return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      JsxRuntime.jsx("div", {
                            className: "mt-4"
                          }),
                      "You currently have a free Pro TAN membership"
                    ]
                  });
    case "PRO_TRIAL" :
        return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      JsxRuntime.jsx("div", {
                            className: "mt-4"
                          }),
                      "Your Pro Trial membership expires on " + formattedDate,
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx(BillingSettingsPageSubscription$UpgradeToProButton, {}),
                            className: "mt-4"
                          })
                    ]
                  });
    default:
      if (cancelAtPeriodEnd) {
        return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      JsxRuntime.jsx("div", {
                            className: "mt-4"
                          }),
                      "Your Pro TAN membership expires on " + formattedDate,
                      JsxRuntime.jsxs("div", {
                            children: [
                              "If you want to reactivate your subscription, please ",
                              JsxRuntime.jsx("a", {
                                    children: "contact us",
                                    className: "text-blue-600 underline",
                                    href: "",
                                    onClick: (function (e) {
                                        e.preventDefault();
                                        show();
                                      })
                                  }),
                              "."
                            ],
                            className: "mt-4 flex flex-row"
                          })
                    ]
                  });
      } else {
        return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      JsxRuntime.jsx("div", {
                            className: "mt-4"
                          }),
                      "Your Pro TAN membership is billed " + intervalPeriod + ". It will be renewed on " + formattedDate,
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                    href: "/subscribe",
                                    size: "small",
                                    children: "Change PRO Plan"
                                  }),
                              cancelProMembershipEnabled ? JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                            href: "/cancel-membership",
                                            size: "small",
                                            children: "Cancel PRO Membership"
                                          }),
                                      className: "ml-2"
                                    }) : null
                            ],
                            className: "mt-4 flex flex-row"
                          }),
                      cancelProMembershipEnabled ? null : JsxRuntime.jsx("div", {
                              children: "Please contact support if you wish to cancel your PRO TAN membership",
                              className: "mt-4"
                            })
                    ]
                  });
      }
  }
}

var make = BillingSettingsPageSubscription;

exports.AccountFragment = AccountFragment;
exports.UpgradeToProButton = UpgradeToProButton;
exports.make = make;
/* Scalars Not a pure module */
